<script setup lang="ts">
import Icon from '@/components/icon/Index.vue'

import { ExclamationCircleIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
  errors?: any[]
}>()

const { errors } = toRefs(props)
</script>

<template>
  <div class="flex gap-1 text-danger text-sm leading-tight items-start items-start">
    <div>
      <Icon
        :icon="ExclamationCircleIcon"
        size="sm"
      />
    </div>
    <div
      v-if="errors?.length"
      class="error-text leading-[20px]"
      v-html="errors[0].$message"
    />
    <slot />
  </div>
</template>

<style scoped lang="scss"></style>
